import axios from "axios";
const baseUrl = require("../BaseURL");





const GetPersonData = async (UserToken,accesstoken) => {
      


    try {
        
      const response = await axios.get(`${baseUrl}/auth/get_bio/${UserToken}`,{
        withCredentials: true,
         headers: {
          'Accept' : 'application/json',
          'Content-Type': 'application/json',
          'authorization': `Bearer ${accesstoken}`
        }
        } 
        ) 
   
       return response.data
   } catch (err) {
     if(err) console.log(err.message)
   }



}



export default GetPersonData;